import { render, staticRenderFns } from "./SecaoGeral.vue?vue&type=template&id=2a5bcca6&scoped=true&"
import script from "./SecaoGeral.vue?vue&type=script&lang=js&"
export * from "./SecaoGeral.vue?vue&type=script&lang=js&"
import style0 from "./SecaoGeral.vue?vue&type=style&index=0&id=2a5bcca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5bcca6",
  null
  
)

export default component.exports